import {
  LineOfCreditDetailBanner,
  LineOfCreditDetailsResult,
  LineOfCreditInstallmentsData,
  Maybe,
  Money,
  SlTitledListComponent,
} from '@varo/graphql-schema-types';
import mapToTransactionSectionList from 'features/lineOfCredit/screens/activeDetailsScreen/adapters/mapToTransactionSectionList';
import GetLineOfCreditDetailsResult from 'services/graphql/queries/VaroLineOfCreditGetDetails';
import { TransactionGroup } from 'shared/components/TransactionSectionList/TransactionSectionList';
import { useQuery } from 'urql';

export interface GetLineOfCreditDetailsResult {
  getLineOfCreditDetailsResult: LineOfCreditDetailsResult;
}

export interface LineOfCreditDetails {
  amountDue: Money;
  dueDate?: Maybe<string | null>;
  isAutoPayEnabled?: Maybe<boolean | null>;
  paymentSchedule?: Maybe<string | null>;
  remainingBalance: Money;
  transactions?: Maybe<SlTitledListComponent[] | null>;
  bannerMessage?: Maybe<LineOfCreditDetailBanner | null>;
  installmentsData?: Maybe<LineOfCreditInstallmentsData | null>;
  transactionsMap: Maybe<TransactionGroup[] | []>;
}

const useVaroLineOfCreditGetDetails = () => {
  const [{ data, fetching, error }, refetch] =
    useQuery<GetLineOfCreditDetailsResult>({
      query: GetLineOfCreditDetailsResult,
      requestPolicy: 'network-only',
    });

  const resultsObj: LineOfCreditDetails = {
    amountDue: data?.getLineOfCreditDetailsResult?.amountDue as Money,
    dueDate: data?.getLineOfCreditDetailsResult?.dueDate,
    isAutoPayEnabled: data?.getLineOfCreditDetailsResult?.isAutopayEnabled,
    paymentSchedule: data?.getLineOfCreditDetailsResult?.paymentSchedule,
    remainingBalance: data?.getLineOfCreditDetailsResult
      ?.remainingBalance as Money,
    bannerMessage: data?.getLineOfCreditDetailsResult?.banner,
    installmentsData: data?.getLineOfCreditDetailsResult?.installmentsData,
    transactionsMap:
      data?.getLineOfCreditDetailsResult?.transactions?.map((curr) => {
        return mapToTransactionSectionList(curr);
      }) || [],
  };

  return {
    error,
    resultsObj,
    fetching,
    refetch,
  };
};

export default useVaroLineOfCreditGetDetails;
